<template>
	<transition name="slide-vertical">
		<li
			class="buttons_stacked"
			v-show="(showAllTimes || hasPickupLocations) && showMe"
			:class="{
				timeHasTransportation: hasPickupLocations,
				hideUnselectedTimes: hideUnselectedTimes,
				selected_time: time.IsSelected,
				not_selected_time: !time.IsSelected,
			}"
		>
			<section
				href="#"
				class="flex button"
				style="position: relative;"
				:class="{
					cursor_normal: time.IsSoldOut,
					time_o: !time.IsSelected,
					'outline bg-mist': time.IsSelected,
				}"
			>
				<hgroup class="mr-1">
					<div>
						<span class="time _redraw" :class="{ 'text-gray': time.IsSoldOut }">
							<div class="flex_start">
								<i v-if="hasPickupLocations" class="material-icons"
									>directions_bus</i
								>
								<span>{{ time.DisplayName }}</span>
							</div>
						</span>
						<span
							v-if="time.Description"
							class="text-blue time_slot_description"
							>{{ time.Description }}</span
						>
						<small
							v-if="!time.IsSoldOut && !time.HidePrices"
							class="time_slot_subtotal"
						>
							<sub-total-tool-tip :time="time" />
							<span>
								<span>&nbsp;<currency :value="simpleTimeSubTotal" /> </span>
								<span
									v-if="
										!isPrivateTour &&
											(!activity.HideSpotsLeftUntilLessThan ||
												time.TotalAvailable <
													activity.HideSpotsLeftUntilLessThan)
									"
								>
									• only {{ time.TotalAvailable }} spot{{
										time.TotalAvailable == 1 ? '' : 's'
									}}
									left
								</span>
							</span>
						</small>
						<small
							v-if="time.HidePrices"
							class="time_slot_subtotal"
							v-bind:class="{ green: time.PriceDifference < 0 }"
						>
							<span v-if="time.PriceDifference > 0">
								<currency :value="time.PriceDifference" /> more
							</span>
							<span v-else-if="time.PriceDifference < 0">
								<currency :value="time.PriceDifference * -1" /> less
							</span>
							<span
								v-if="
									!isPrivateTour &&
										(!activity.HideSpotsLeftUntilLessThan ||
											time.TotalAvailable < activity.HideSpotsLeftUntilLessThan)
								"
							>
								<span v-if="time.PriceDifference != 0">&nbsp;•</span> only
								{{ time.TotalAvailable }} spot{{
									time.TotalAvailable == 1 ? '' : 's'
								}}
								left
							</span>
						</small>
						<pre>time.SubTotal: {{ time.SubTotal }}</pre>
						<pre>
time.TotalAvailable: {{ time.TotalAvailable }}
            </pre>
						<pre>time.ShowSoldOutTimes: {{ time.ShowSoldOutTimes }}</pre>
						<pre>time.IsSoldOut: {{ time.IsSoldOut }}</pre>
						<pre>time.CallToBook: {{ time.CallToBook }}</pre>
						<pre>addOns: {{ time.AddOns }}</pre>
					</div>
				</hgroup>
				<div v-if="time.CallToBook">
					<call-to-book />
				</div>
				<div v-else-if="time.IsSoldOut">
					<small class="text-gray" style="font-size: 14px; font-weight: 500;"
						>Sold out</small
					>
				</div>
				<div v-else>
					<button
						@click.prevent="changeTime()"
						class="button link tiny pl-0 pr-0 text-right"
						v-if="time.IsSelected && !isLoading"
					>
						Change time
					</button>

					<button
						v-else
						class="button blue small"
						@click.prevent="selectTime"
						:class="{
							button_loading: isLoading && time.IsSelected,
						}"
					>
						{{ isPackage ? 'Select' : 'Book' }}
					</button>
				</div>
			</section>

			<router-link
				v-if="
					time.IsSelected &&
						hasPickupLocations &&
						activeProductDetails.NeedTransportation
				"
				class="button outline pickup-location-ui"
				:class="{
					'small bg-mist': time.PickupLocation,
					large: !time.PickupLocation,
				}"
				:to="'transportation/' + entityHierarchyKey + '/' + time.Value"
			>
				<span v-if="time.PickupLocation" class="flex hgroup">
					<span>
						{{ time.PickupLocation.LocationName }}
						<br />
						<small
							>{{ time.PickupLocation.DepartureDisplayTime }} pick-up</small
						>
						<small
							>{{ time.PickupLocation.DistanceFromHotel }} miles from your
							hotel</small
						>
					</span>
					<small class="text-blue">Edit</small>
				</span>
				<span v-else class="flex">
					<span class="text-blue">Select pick-up location</span>
				</span>
			</router-link>

			<router-link
				v-if="time.IsSelected && time.AddOns && time.AddOns.length"
				class="button outline pickup-location-ui small bg-mist"
				:to="'addons/' + entityHierarchyKey + '/' + time.Value"
			>
				<span v-if="addOnsHaveQuantity" class="flex hgroup">
					<span>
						Add-ons
						<br />

						<small
							v-show="addon.Quantity"
							v-for="(addon, i) in time.AddOns"
							:key="'times-ui-row-' + time.Value + '-' + i"
							>{{ addon.AddOnName }}
							{{ addon.IsBoolean ? '' : ' x ' + addon.Quantity }}</small
						>
					</span>
					<small class="text-blue">Edit</small>
				</span>
				<span v-else class="flex hgroup">
					<span class=""
						>Add-ons
						<br />
						<small>None selected</small>
					</span>
					<small class="text-blue">Edit</small>
				</span>
			</router-link>

			<!--      <pre>timeSlotRequirements: {{ timeSlotRequirements }}</pre>-->
			<!--      <pre>time.AddOnsSkipped: {{ time.AddOnsSkipped }}</pre>-->
			<!-- <pre>time.Rates: {{time.Rates.length}}</pre> -->

			<!-- <pre v-if="time.Requirements">time.Requirements: {{time.Requirements.length}}</pre> -->
			<!-- <pre>time: {{time}}</pre> -->
			<!-- <pre>timeSlotRequirements::::: {{timeSlotRequirements}}</pre> -->

			<!-- <pre>time.IsSelected: {{time.IsSelected}}</pre> -->
			<!-- <pre>time.Rates: {{time.Rates}}</pre> -->
		</li>
	</transition>
</template>

<script>
	import { mapGetters } from 'vuex';

	// components
	import SubTotalToolTip from './SubTotalToolTip.vue';

	// mixins
	import postTimeSelection from '../mixins/postTimeSelection.js';
	import addToCart from '../mixins/addToCart.js';

	export default {
		props: [
			'isLoading',
			'time',
			'name',
			'activity',
			'id',
			'value',
			'isPackage',
			'showAllTimes',
			'entityHierarchyKey',
			'hideUnselectedTimes',
			'isPrivateTour',
		],

		components: {
			SubTotalToolTip,
		},

		mixins: [postTimeSelection, addToCart],

		data: function() {
			return {
				style: 'opacity: 1',
			};
		},

		computed: {
			...mapGetters(['activeProductDetails', 'productSubTotal']),

			simpleTimeSubTotal() {
				var total = this.time.SubTotal;

				this.time.AddOns.forEach((addon) => {
					total +=
						(addon.PublishedPrice -
							(addon.AddOnDiscount ? addon.AddOnDiscount : 0)) *
						addon.Quantity;
				});

				return total;
			},

			showMe() {
				// should I show this time?
				return !this.hideUnselectedTimes || this.time.IsSelected;
			},

			hasPickupLocations() {
				return this.time.PickupLocations.length;
			},
			// entityHierarchyKey() {
			//   return this.activeProductDetails.EntityHierarchyKey;
			// },
			addOnsHaveQuantity() {
				var f = this.time.AddOns.find((ele) => {
					return ele.Quantity > 0;
				});

				if (f) {
					return true;
				}

				// variant quantity
				let q = this.time.AddOns.reduce((p, c) => {
					p += c.Variants.reduce((v, c) => (v += c.Quantity), 0);
					return p;
				}, 0);

				if (q > 0) return true;

				return false;
			},
		},

		methods: {
			// updateInput: function(event) {
			//   this.$emit("input", event.target.value);
			// },

			changeTime() {
				if (this.isLoading) {
					return;
				}
				//console.log("changeTime()");
				this.time.AddOns.forEach((add) => {
					///add.Quantity = 0;
					this.$set(add, 'Quantity', 0);
				});

				// this.time.Rates.forEach(r => {
				//   ///add.Quantity = 0;
				//   this.$set(r, "Participants", 0);
				// });

				// record this time in the clearedTimes array for later use.
				if (!this.activity.clearedTimes) {
					this.$set(this.activity, 'clearedTimes', []);
				}
				this.activity.clearedTimes.push(this.time);

				//console.log("this.activity.clearedTimes", this.activity.clearedTimes);

				//alert(this.time.DisplayName);

				this.$set(this.time, 'IsSelected', false);
				this.$set(this.time, 'PickupLocation', null);

				this.time.PickupLocations.forEach((location) => {
					//location.IsSelected = false;
					this.$set(location, 'IsSelected', false);
				});

				// need to clear time for the TimesClone
				let findTimeClone = this.activity.TimesClone.find((ele) => {
					return ele.Value === this.time.Value;
				});

				if (findTimeClone) {
					findTimeClone.AddOns.forEach((add) => {
						this.$set(add, 'Quantity', 0);
					});

					this.$set(findTimeClone, 'IsSelected', false);
					this.$set(findTimeClone, 'PickupLocation', null);

					findTimeClone.PickupLocations.forEach((location) => {
						this.$set(location, 'IsSelected', false);
					});
				}
			},

			selectTime() {
				// why did I take this off?
				// because, in order to facilitate undoing the addOns and pickuplocations
				// selecting time does not actually change the value for IsSelected
				// that needs to happen in the postTimeSelection
				// this.$set(this.time, "IsSelected", true);
				// console.log("Select Time")
				if (this.isLoading) {
					return;
				}
				if (this.isPackage) {
					this.advancePostTimeSelection('simple', this.time.Value, this.$route);
				} else {
					// this.isLoading = true
					this.$emit('didSelectBook', this.time);
				}
			},
		},
	};
</script>

<style>
	.green {
		color: #090 !important;
	}
</style>
